import ITheme from "@/interfaces/iTheme";
import backgroundImage from "@assets/themes/cyberIcons/cyberIconsBackgroundImage.svg";

export class CyberIconsTheme implements ITheme
{
    static Id = 'cybericons';
    id = CyberIconsTheme.Id;

    name = 'Cyber Icons';

    colors = {
                application: '#3C5A82', //#051c29
                text: '#E0E0E0',
                confirm: '#21b68b',
                confirmText: '#000000',
                secondary: '#62B4E4',

                // Challenge card colors
                solved: '#69a9db',
                solvedText: '#000000',
                locked: '#0009',
                unsolved: '#21b68b',
                unsolvedText: '#000000',
                noMoreAttempts: '#E5803C',
                noMoreAttemptsText: '#000000',
                disabled: '#E5803C',
                disabledText: '#000000',

                windowBackground: '#0009',
                windowText: '#FFF',
                windowBorder: '#FFFFFF1F',

                tag: '#62B4E4',
                activeTab: '#62B4E4',
                dialogText: '#303030',
                dialogLink: '#3C5A82',
                dialogSuccessText: '#4CAF50',
                dialogFailureText: '#F44336',
                dialogIcon: '#553A97',
                success: '#4CAF50',
                warning: '#FF9800',

                // Table
                tableHeaderActionButtons: 'white',
                tableHeaderSelectAllButtons: '#62B4E4',

                //settings and bulk select checkboxes 
                checkedFill: '#1C1C52',
                settingsInputError: '#DD4242',
                settingsInputErrorShadow: '#0B0B21',

                // focus indicators
                focusVisibleIndicator: '#1C1C52',

                // the most common color from the background image with sufficient contrast
                backgroundImageColor: '#1C1C52',

                actionButtonBackground: '#1C1C52',
                actionButtonText: 'white',
             };
        
    fontFamily = "ShareTech";
    landingFontFamily = "ShareTechMono";
    backgroundImage = backgroundImage;
    isDark = true;
}
